export default __webpack_public_path__ + "19ef239.png";